import React from 'react';
import { Image, View } from 'react-native-web';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import MenuServicesLayout from '../../../menuLayout/MenuServicesLayout';
import ChatBubbles from '../../AuxiliaryComponent/Images/ChatBubbles';
import FullPageSpecialSimulator from '../FullPageSpecialSimulator';
import PhoneFrame from '../../AuxiliaryComponent/Images/PhoneFrame';

//= ========================================================================

const SplashScreenMainFP = ({
  globJSON,
  simPlatform,
  imageSource,
  LabelInputText,
  TopTitle,
  withStatusBar,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { promotion } = globJSON.configurations.onboarding;

  const myStyles = {
    chatSep: {
      width: 184,
      height: 3,
      marginLeft: 28,
      backgroundColor: colors.primary_cta_color,
    },
    keyboardBox: {
      width: 184,
      height: simPlatform === Android ? 110 : 130,
      marginLeft: 28,
      backgroundColor: colors.app_background_color,
      overflow: 'hidden',
    },
    menu_screenshot: {
      width: 183,
      height: simPlatform === Android ? 121 : 134,
      borderBottomLeftRadius: simPlatform === Android && 16,
      borderBottomRightRadius: simPlatform === Android && 16,
      marginLeft: 28,
      marginTop: simPlatform === Android ? 73 : 90,
      position: 'absolute',
      backgroundColor: colors.border_light_color,
    },
    blueLine: {
      marginStart: 35, marginTop: simPlatform === Android ? 3 : 10, marginBottom: 7,
    },
  };

  return (
    <FullPageSpecialSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      WithImageBackground={imageSource}
      TopTitle={TopTitle}
      LabelInputText={LabelInputText}
      numOfPointThatGetColor={3}
      slideshowRefs={slideshowRefs}
      withStatusBar={withStatusBar}
    >
      <View>
        <View style={myStyles.blueLine}>
          <ChatBubbles
            simPlatform={simPlatform}
            backgroundColor={colors.app_background_color}
            ToptintColor={colors.disabled_cta_color}
            BottomtintColor={colors.primary_cta_color}
          />
        </View>
        <View style={myStyles.chatSep} />
        {promotion.onboarding_screen_2_is_automatic || !promotion.menu_screenshot.fUri ? (
          <View style={myStyles.keyboardBox}>
            <MenuServicesLayout globJSON={globJSON} multi={0.9} />
          </View>
        ) : (
          <Image
            fadeDuration={0}
            style={myStyles.menu_screenshot}
            source={promotion.menu_screenshot.fUri}
          />
        )}
      </View>
      {simPlatform !== Android && withStatusBar && (<PhoneFrame />) }
    </FullPageSpecialSimulator>
  );
};

export default SplashScreenMainFP;
